import { Button } from '@ps/sports-ui-component-library';
import { useTrackers } from '@ps/web-shared-analytics';
import { Link, Translation, useTrackingLabel } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import { TXTWCL_Deposit_Funds } from './DepositButton.messages.json';

const cashierPath = '/account/cashier/home';

const DepositButton: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const { buttonPressed } = useTrackers();
  const buttonName = useTrackingLabel(TXTWCL_Deposit_Funds);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const cashierHref = useSelector(select.cms.getCashierHref);

  return (
    <Button
      as={isEmbedded ? Link : undefined}
      href={cashierHref}
      onClick={() => {
        buttonPressed({ buttonName });
        !isEmbedded && modal.enqueue({ path: cashierPath });
      }}
      size="medium"
    >
      <Translation {...TXTWCL_Deposit_Funds} />
    </Button>
  );
};

export default DepositButton;
